import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../index';
import {
  Wrapper, ErrorIcon
} from './styled';

const StringInput = ({
  asterisk, required, title, placeholder, defaultValue, onChange, disabled, error, children, useIcon, ...props
}) => (
  <Wrapper>
    <Input
      asterisk={ asterisk }
      required={ required }
      title={ title }
      placeholder={ placeholder }
      defaultValue={ defaultValue }
      onChange={ onChange }
      disabled={ disabled }
      error={ error }
      // eslint-disable-next-line react/jsx-props-no-spreading
      { ...props }
    />
    {useIcon && <ErrorIcon error={ error } />}
    { children }
  </Wrapper>
);

export default StringInput;

StringInput.propTypes = {
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node,
  useIcon: PropTypes.bool
};

StringInput.defaultProps = {
  defaultValue: '',
  disabled: false,
  required: false,
  error: '',
  placeholder: '',
  title: '',
  children: null,
  useIcon: true
};
